import type { CardPosition } from '../../types'

export const EMPTY_STATE_WIDTH = 420
export const EMPTY_STATE_HEIGHT = 300
export const EMPTY_STATE_PADDING = 32

/** Centered on canvas origin (0, 0). */
export const EMPTY_STATE_POSITION: CardPosition = {
  x: -EMPTY_STATE_WIDTH / 2,
  y: -EMPTY_STATE_HEIGHT / 2,
}
